"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const BaseRestClient_1 = require("./BaseRestClient");
class ProfileRestClient extends BaseRestClient_1.BaseRestClient {
    getUserProfileInfo(skypetoken) {
        const uri = '/v1/users/self/profile';
        const options = {
            headers: {
                'X-Skypetoken': skypetoken,
            },
        };
        return this.performApiGet(uri, options);
    }
}
exports.default = new ProfileRestClient(config_1.default.urls.api.profile);
